import React from "react";
import { StoreTemplate } from "../../Templates/StoreTemplate";

export const Store = () => {
  return <StoreTemplate />;
};
